import React from 'react';
import { Link } from 'gatsby';
// import Code from './Code';
import { ExternalLink } from '../StyledComponents/Links';
import { H1, H2, H3, H4, H5, H6, Em, Paragraph } from './TextStyles';

export default {
	h1: (props) => <H1 {...props} />,
	h2: (props) => <H2 {...props} />,
	h3: (props) => <H3 {...props} />,
	h4: (props) => <H4 {...props} />,
	h5: (props) => <H5 {...props} />,
	h6: (props) => <H6 {...props} />,
	p: (props) => <Paragraph {...props} />,
	pre: (props) => <pre {...props} style={{ marginBottom: '1.5rem' }} />,
	ExternalLink: ({ children, ...props }) => (
		<ExternalLink {...props}>{children}</ExternalLink>
	),
	em: (props) => <Em {...props} />,
	Link: (props) => <Link {...props}>{props.children}</Link>,
	ol: (props) => (
		<ol {...props} style={{ listStyle: 'decimal', marginLeft: '1.75rem' }}>
			{props.children}
		</ol>
	),
	// code: Code,
};
